import styled from 'styled-components';
import {
  getSpace,
  gridContainer,
  setGridColumns,
  mq,
  getGridColumns
} from '../../../stylesheets/tools';

const StyledTargetGroups = styled.section`
  .container__wrapper {
    padding: 120px 20px;

    ${mq('m')} {
      padding: 180px 20px;
    }
  }

  .target-groups__headline {
    margin-bottom: ${getSpace('xl')};
    text-align: center;
  }

  .target-groups__grid {
    ${gridContainer()}
    ${setGridColumns('1fr', 1)}
    gap: 40px;

    ${mq('m')} {
      gap: 20px 80px;
      ${setGridColumns('1fr', 2)}
    }

    .target-groups__grid-item {
      position: relative;

      &:hover {
        .shaped-image__item {
          transform: scale(1.25);
        }
        svg {
          transform: translateX(10px);
        }
      }

      img {
        height: auto;
        aspect-ratio: 1;
        object-fit: cover;
      }

      &:nth-child(1) {
        transform: rotate(-2deg);

        img {
          aspect-ratio: 16 / 8;
        }
      }
      &:nth-child(2) {
        transform: rotate(6deg);
      }
      &:nth-child(3) {
        transform: rotate(-3deg);

        ${mq('m')} {
          margin-top: 60px;
        }
      }
      &:not(.half-grid) {
        ${getGridColumns([1, 1], { m: [1, 3] })}
      }

      .target-groups__grid-cta {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        gap: 20px;

        ${mq('m')} {
          margin-top: 30px;
        }

        svg {
          transition: all 0.25s ease;
        }

        .target-groups__grid-cta-title {
          text-align: right;
          max-width: 280px;
          display: block;
          word-break: auto-phrase;
        }

        a {
          flex: none;

          .target-groups__grid-cta-stretched {
            position: absolute;
            inset: 0;
            z-index: 1;
          }
        }
      }
    }
  }
`;

export default StyledTargetGroups;
